import { Method, ResponseType } from "axios";

export type THttpRequest = {
  url: string;
  baseUrl?: string;
  params?: any;
  method: THttpMethod;
  responseType?: ResponseType;
  body?: any;
  headers?: any;
};

export interface IHttpClient {
  request: <T = any>(data: THttpRequest) => Promise<THttpResponse<T>>;
}

export type THttpMethod = Method;

export enum EHttpStatusCode {
  ok = 200,
  created = 201,
  noContent = 204,
  badRequest = 400,
  unauthorized = 401,
  forbidden = 403,
  notFound = 404,
  serverError = 500,
}

export type THttpResponse<T = any> = {
  statusCode: EHttpStatusCode;
  body?: T;
};
